import { animate, animation, keyframes, style } from '@angular/animations';

export const bounce = animation(
  [
    animate(
      '{{ duration }}ms {{ delay }}ms {{ easing }}',
      keyframes([
        style({ transform: 'translateY(0)', offset: 0 }),
        style({ transform: 'translateY(-{{ translateY }})', offset: 0.2 }),
        style({ transform: 'translateY(0)', offset: 0.4 }),
        style({ transform: 'translateY(-{{ translateY2 }})', offset: 0.6 }),
        style({ transform: 'translateY(0)', offset: 0.8 }),
        style({ transform: 'translateY(0)', offset: 1 }),
      ]),
    ),
  ],
  {
    params: {
      duration: '800',
      delay: '0',
      easing: 'ease-out',
      translateY: '8px', // initial bounce height
      translateY2: '4px', // second bounce height
    },
  },
);
